module.exports = __webpack_public_path__ + "525074686dfb8aa36b1b92e29de467ac.woff";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/Italic/OpenSans-Italic.woff?v=1.1.0
// module id = 989
// module chunks = 0